import React from "react"
import { AbsenceStatus, AbsenceType } from "../types"
import BaseModal from "../../../components/layout/BaseModal"
import dayjs from "dayjs"
import { AbsencesTypes } from "../../../api/constants"
import { ReactComponent as CHECK } from "../../../assets/ApprovaICON.svg"
import BasePopover from "../../../components/elements/BasePopover"

type AbsenceModalType = {
    modalId: number
    absence: AbsenceType
    handleSolveConflictAbsence: (parentId: string, conflictId: string) => void
    handleCancelAbsence: (id: string) => void
    handleRejectAbsence: (id: string) => void
    handleApproveAbsence: (id: string) => void
}

export default function AbsenceModal(props: AbsenceModalType) {
    return (
        <BaseModal
            modalId={props.modalId}
            title="Abwesenheit"
            size="fit"
            bottomRow={
                <div className="flex flex-row justify-between w-full">
                    {props.absence?.status !== AbsenceStatus.REJECTED && props.absence?.type !== AbsencesTypes.SICK  && props.absence?.status !== AbsenceStatus.CANCELLED && props.absence?.status !== AbsenceStatus.APPROVED && (
                        <button className="btn btn-sm btn-error" onClick={() => props.handleRejectAbsence(props.absence._id)}>Ablehnen</button>
                    )}
                    {props.absence?.status === AbsenceStatus.APPROVED && dayjs(props.absence?.startDate).isAfter(dayjs()) && (
                        <button className="btn btn-sm btn-error" onClick={() => props.handleCancelAbsence(props.absence._id)}>Stornieren</button>
                    )}
                    {props.absence?.status === AbsenceStatus.IN_REVIEW && <button className="btn btn-sm btn-primary" onClick={() => props.handleApproveAbsence(props.absence._id)}>Genehmigen</button>}
                </div>
            }>
            <div className="flex flex-row justify-between w-96 text-xs pt-2">
                <p className="w-40">Erstellt am:</p>
                <p>{dayjs(props.absence?.createdAt).format("DD.MM.YYYY")}</p>
            </div>
            <div className="flex flex-row justify-between w-96 text-xs">
                <p className="w-40">Zuletzt bearbeitet am:</p>
                <p>{dayjs(props.absence?.updatedAt).format("DD.MM.YYYY")}</p>
            </div>
            <div className="border-b w-full my-2" />
            <div className="flex flex-row justify-between w-96 text-xs">
                <p className="w-40">Mitarbeiter:</p>
                <p>
                    {props.absence?.employee?.first_name} {props.absence?.employee?.last_name}
                </p>
            </div>
            <div className="flex flex-row justify-between w-96 text-xs">
                <p className="w-40">Start:</p>
                <p>{dayjs(props.absence?.startDate).format("DD.MM.YYYY")}</p>
            </div>
            <div className="flex flex-row justify-between w-96 text-xs">
                <p className="w-40">Ende:</p>
                <p>{dayjs(props.absence?.endDate).format("DD.MM.YYYY")}</p>
            </div>
            <div className="flex flex-row justify-between w-96 text-xs">
                <p className="w-40">Typ:</p>
                <p>{props.absence?.type}</p>
            </div>
            <div className="flex flex-row justify-between w-96 text-xs">
                <p className="w-40">Status:</p>
                <p>{props.absence?.status}</p>
            </div>
            <div className="flex flex-row justify-between w-96 text-xs pb-2">
                <p className="w-40">Notiz:</p>
                <p className="text-end">{props.absence?.comment ?? "Keine Notiz"}</p>
            </div>
            {props.absence?.conflictingAbsences && props.absence?.conflictingAbsences?.length > 0 && (
                <>
                    <div className="border-b w-full my-2" />
                    <div className="flex flex-col justify-between w-96 text-xs">
                        <p className="w-full">Konfliktende Abwesenheiten:</p>
                        {props.absence?.conflictingAbsences?.map((absence) => (
                        <div key={absence._id} className="flex flex-row justify-between items-center border-l-2 mt-2">
                            <div className="pl-2">
                                <p>
                                    {dayjs(absence.startDate).format("DD.MM.YYYY")} - {dayjs(absence.endDate).format("DD.MM.YYYY")}
                                </p>
                                <p>
                                    {absence.type} von {absence.employee?.first_name} {absence.employee?.last_name}
                                </p>
                            </div>
                            <BasePopover
                                label="Konflikt auflösen"
                                text="Der Konflikt wurde gelöst bzw. es handelt sich nicht um einen Konflikt."
                                okButtonClick={() => props.handleSolveConflictAbsence(props.absence._id, absence._id)}>
                                <CHECK className="w-5 h-5" />
                            </BasePopover>
                        </div>
                    ))}
                    </div>
                </>
            )}
        </BaseModal>
    )
}
